import ProductFullStaticBleedHero from './ProductFullStaticBleedHero';

export default ProductFullStaticBleedHero;
